export const editAnswerText = (isMulti: boolean, answered: boolean) => {
  switch (answered) {
    case true:
      return isMulti ? 'Edit Answers' : 'Edit Answer'
    default:
      return 'Go To Question'
  }
}
